import React, { useState, useEffect, useRef } from 'react';
import { API } from '../../../API/API';
import DataGrid, { Column, Export, Item, SearchPanel, Selection, Toolbar, LoadPanel, TotalItem, Summary } from 'devextreme-react/data-grid';
import { Lookup as FieldLookup, DropDownOptions } from 'devextreme-react/lookup';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { LoadScreen } from '../../../components/LoadScreen/LoadScreen';
import LoadSpin from '../../../components/LoadSpin/LoadSpin';
import { locationData } from '../../../const/Const';

const SocialInsurance = (props) => {

    const gridRef = useRef();
    const [data, setData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [sFilter, setSFilter] = useState();

    const [loading, setLoading] = useState(false);
    const [loadingScreen, setLoadingScreen] = useState(false);

    const getFilterData = async () => {
        let tFilterData = [];
        let tSFilter = null;
        try {
            setLoadingScreen(true);
            await API.get("/api/payroll/getSalaryYearAndMonth").then(response => {
                if (response.status == 200 && response?.data?.retType == 0) {
                    response?.data?.retData?.map(r => {
                        tFilterData.push({
                            key: r?.salaryyear + "-" + r?.salarymonth,
                            text: r?.salaryyear + "-" + r?.salarymonth
                        });
                    });
                };
            });
        } finally {
            setLoadingScreen(false);
        }

        if (tFilterData?.length > 0) {
            tSFilter = tFilterData[0].key;
        }

        setSFilter(tSFilter);
        setFilterData(tFilterData);
    }

    const getData = async () => {
        let tData = [];
        if (sFilter) {
            try {
                setLoading(true);
                await API.get("/api/payroll/report/getNDData?salaryyear=" + sFilter.split('-')[0] + "&salarymonth=" + sFilter.split('-')[1]).then(response => {
                    if (response?.status == 200 && response?.data?.retType == 0) {
                        tData = response?.data?.retData;
                    }
                });

                if (tData?.length > 0) {
                    let tDataEmp = [];
                    await API.post("/api/humanresource/employee/getEmpsBasicInfo", tData?.map(r => r.empid)).then(response => {
                        if (response?.status == 200 && response?.data?.rettype == 0) {
                            tDataEmp = response?.data?.retdata;
                        }
                    });

                    if (tDataEmp?.length > 0) {
                        for (let i = 0; i < tData?.length; i++) {
                            let tIndex = tDataEmp.map(remp => remp.empid).indexOf(tData[i].empid);
                            if (tIndex >= 0) {
                                tData[i] = { ...tData[i], ...tDataEmp[tIndex] };

                                if (tData[i].address?.split(",")?.length > 0) {
                                    let tLocData = locationData?.find(r => r.text?.toString()?.toLocaleLowerCase() == tData[i].address?.split(",")[0]?.toString()?.toLocaleLowerCase());
                                    if (tLocData?.key) {
                                        tData[i] = { ...tData[i], loc_code: tLocData?.key };
                                    }
                                }

                            }
                        }
                    }
                }

            } finally {
                setLoading(false);
            }
        }
        setData(tData);
    }

    useEffect(() => {
        getFilterData();
    }, []);

    useEffect(() => {
        getData();
    }, [sFilter]);

    const filterOnChange = async (e) => {
        if (e?.value) {
            setSFilter(e?.value);
        }
    }

    if (loadingScreen) {
        return (
            <LoadScreen />
        );
    }

    return (
        <div style={{ height: 'calc(100vh - 150px)', width: '100%' }}>
            <PageHeader
                title='Нийгмийн даатгалын тайлан' />
            <div style={{ padding: 16 }}>
                {loading ? <LoadSpin /> : (
                    <DataGrid
                        ref={gridRef}
                        dataSource={data}
                        showBorders={true}
                        hoverStateEnabled={true}
                        wordWrapEnabled={false}>
                        <SearchPanel visible={true} highlightCaseSensitive={true} />
                        <Export enabled={true} />
                        <LoadPanel enabled />
                        <Toolbar>
                            <Item location="before">
                                <FieldLookup
                                    onValueChanged={filterOnChange}
                                    displayExpr="text"
                                    width={250}
                                    wrapItemText={true}
                                    valueExpr="key"
                                    searchEnabled={false}
                                    showCancelButton={false}
                                    items={filterData}
                                    defaultValue={sFilter}>
                                    <DropDownOptions
                                        hideOnOutsideClick={true}
                                        showTitle={false}

                                    />
                                </FieldLookup>
                            </Item>
                            <Item name="searchPanel" />
                            <Item name="exportButton" />
                        </Toolbar>
                        <Selection
                            mode="single"
                        />
                        <Column dataField="lastname" caption="ovog" headerCellRender={(data) => { return "Овог" }} />
                        <Column dataField="firstname" caption="name" headerCellRender={(data) => { return "Нэр" }} />
                        <Column dataField="regno" caption="register" headerCellRender={(data) => { return "Регистер" }} />
                        <Column dataField="nd_dugaar" caption="nd_dugaar" headerCellRender={(data) => { return "НДД-н №" }} />
                        <Column dataField="emd_dugaar" caption="emd_dugaar" headerCellRender={(data) => { return "ЭМД-н №" }} />
                        <Column dataField="ssiincome" caption="undsen_nemegdel_tsalin" dataType="number" format="###,###,###,###,##0.00" headerCellRender={(data) => { return "Үндсэн ба нэмэгдэл" }} />
                        <Column dataField="shagnalt_tsalin" caption="shagnalt_tsalin" headerCellRender={(data) => { return "Шагналт цалин" }} />
                        <Column dataField="bonustotal" caption="busad_nemegdel_tsalin" dataType="number" format="###,###,###,###,##0.00" headerCellRender={(data) => { return "Бусад нэмэгдэл" }} />
                        <Column dataField="hool_unaa" caption="hool_unaa" headerCellRender={(data) => { return "Хоол унаа" }} />
                        <Column dataField="tulee_nuurs" caption="tulee_nuurs" headerCellRender={(data) => { return "Түлээ нүүрс" }} />
                        <Column dataField="total" caption="niit" dataType="number" format="###,###,###,###,##0.00" headerCellRender={(data) => { return "Нийт" }} />
                        <Column dataField="insuretypecode" caption="daat_turul" headerCellRender={(data) => { return "ДТ" }} />
                        <Column dataField="hyazgaar" caption="hyazgaar" headerCellRender={(data) => { return "Хязгаар" }} />
                        <Column dataField="countryid" caption="countryid" headerCellRender={(data) => { return "Улс" }} />
                        <Column dataField="occ_code" caption="occ_code" headerCellRender={(data) => { return "Мэргэжил" }} />
                        <Column dataField="loc_code" caption="loc_code" headerCellRender={(data) => { return "Байршил" }} />
                        <Column dataField="mobilephone" caption="cellphone" headerCellRender={(data) => { return "Утас" }} />
                        <Column dataField="email" caption="email" headerCellRender={(data) => { return "Имэйл" }} />
                        <Summary>
                            <TotalItem
                                column="total"
                                summaryType="sum"
                                displayFormat="{0}"
                                valueFormat="###,###,###,###,##0.00"
                            />
                            <TotalItem
                                column="ssiincome"
                                summaryType="sum"
                                displayFormat="{0}"
                                valueFormat="###,###,###,###,##0.00"
                            />
                            <TotalItem
                                column="bonustotal"
                                summaryType="sum"
                                displayFormat="{0}"
                                valueFormat="###,###,###,###,##0.00"
                            />
                        </Summary>
                    </DataGrid>
                )}
            </div>
        </div >
    );
}



export default SocialInsurance;